// extracted by mini-css-extract-plugin
export default {"main":"styles_main__SfFP-","loginBox":"styles_loginBox__BCLP8"};